import ProductImage from '@assets/png/product.png';
import AvatarImage from '@assets/svg/avatar-placeholder.svg';
import { IAssetLog } from '@models/AssetLog.model';
import { format } from 'date-fns';
import { useContext } from 'react';
import Rolling from '@assets/gif/rolling.gif';
import { ActivityHistoryContext } from './ActivityHistory.query';

import {
  Container,
  Title,
  Header,
  Item,
  RowDiv,
  AssetImg,
  Text,
  TriggeredByDiv,
  AvatarImg,
  EventName,
  DateContent,
  LoadMore,
  LoadingText,
  LoadingImg,
  WrapperDiv,
  SerialDiv,
  ContentContainer,
  Divider,
} from './ActivityHistory.styles';
import { ActivityHistoryValues } from './Components/ActivityHistoryValues.tsx/ActivityHistoryValues';
import { ActivityHistoryLoading } from './Components/ActivityHistoryLoading/ActivityHistory.loading';

export const ActivityHistoryRaw = () => {
  const { ActivityHistoryData, ref, hasMore, isLoading } = useContext(
    ActivityHistoryContext,
  );

  const EventNameFormated = (data: IAssetLog) => {
    if (data.eventType === 'Comment') return 'added a comment:';
    if (data.eventName === 'Updated Status comment')
      return 'Updated Status with comment:';
    return data.eventName;
  };

  const TextDialog = (data: IAssetLog) => {
    if (data.eventType === 'Comment') return true;
    if (data.eventName === 'Updated Status comment') return true;
    if (data.eventName === 'Updated Description field') return true;
    return false;
  };
  return (
    <Container>
      <Header>
        <Title>Activity History</Title>
      </Header>

      <ContentContainer>
        {!isLoading ? (
          ActivityHistoryData?.sort((a, b) => {
            if (!a.createdAt) return 1;
            if (!b.createdAt) return -1;
            return (
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );
          }).map(data => {
            if (
              data.eventName === 'Updated Status comment' &&
              data.newValue === ''
            )
              return <div />;
            if (
              data.eventName === 'Updated Description field' &&
              data.newValue === ''
            )
              return <div />;
            return (
              <Item key={data._id}>
                <RowDiv>
                  <AssetImg
                    src={data.image || ProductImage}
                    brokenSrc={ProductImage}
                  />
                  <Text>
                    {data.assetName ? data.assetName : data.assetModel}
                  </Text>
                  {data.serial && <SerialDiv>{data.serial}</SerialDiv>}
                </RowDiv>

                <RowDiv className="lowerDiv">
                  <WrapperDiv>
                    <TriggeredByDiv>
                      <AvatarImg
                        src={data.triggeredByAvatar}
                        brokenSrc={AvatarImage}
                      />
                      {data.triggeredBy}
                    </TriggeredByDiv>

                    <EventName>{EventNameFormated(data)}</EventName>

                    {!TextDialog(data) && <ActivityHistoryValues data={data} />}
                  </WrapperDiv>

                  <DateContent>
                    {data.createdAt && format(new Date(data.createdAt), 'PP')} -{' '}
                    {data.createdAt && format(new Date(data.createdAt), 'p')}
                  </DateContent>
                </RowDiv>

                {TextDialog(data) && (
                  <>
                    <Divider height="10px" />
                    <ActivityHistoryValues data={data} />
                  </>
                )}
              </Item>
            );
          })
        ) : (
          <ActivityHistoryLoading />
        )}

        <LoadMore ref={ref}>
          {hasMore ? (
            <LoadMore>
              <LoadingText>Loading more</LoadingText>
              <LoadingImg src={Rolling} alt="loading" />
            </LoadMore>
          ) : (
            <div />
          )}
        </LoadMore>
      </ContentContainer>
    </Container>
  );
};
